<template>
  <div>
    <a-requete-toolbar v-model="projection" :etat="etat" :association="association" :radieeOffice="radieeOffice" :rectifieeOffice="rectifieeOffice"/>

    <v-container>
      <v-row dense>
        <v-col cols="12">
          <v-card class="rounded-lg">
            <v-card-title class="am-t2 bold">
              <v-row dense class="space-between align-center">
                <div>Documents communiqués par le tribunal</div>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row>
                <template v-if="aucunDocument">
                  <v-col cols="12">
                    <v-card-text class="text-center text-body-1 ma-5">
                      Aucun document pour le moment.
                    </v-card-text>
                  </v-col>
                </template>
                <template v-else>
                  <v-row class="full-width" v-if="!aucunDocumentFinTraitement">
                    <v-col
                      v-for="(doc,index) in documentsTriesFinTraitement"
                      :key="doc.uuid"
                      cols="12"
                      sm="6"
                      lg="4"
                    >
                      <a-document-requete-card :value="doc" :data-testid="`requete-fin-traitement-${index}`"/>
                    </v-col>
                  </v-row>
                  <v-row class="full-width" v-if="!aucunDocumentDDP">
                    <v-col
                      v-for="(doc,index) in documentsTriesDDP"
                      :key="doc.uuid"
                      cols="12"
                      sm="6"
                      lg="4"
                    >
                      <a-document-requete-card :value="doc" :data-testid="`requete-demande-pieces-${index}`"/>
                    </v-col>
                  </v-row>
                </template>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import makeRouteLoader from "@/mixins/makeRouteLoader";
import { requeteService } from "@/services";

const TYPES_DEMANDE_PIECES = ["DEMANDE_PIECES", "AVIS_FINS_PAIEMENT"];

function extraitCodePiece({ nom }) {
  const match = /.*-(\d+)-.*$/.exec(nom);
  return match ? parseInt(match[1]) : -1;
}

function extraitPriorite({ type }) {
  if ("NOTIFICATION_DECISION" === type) return 0;
  else if ("ORDONNANCE" === type) return 1;
  return 2;
}

function compareBool(l, r) {
  if (!!l && !r) {
    return -1;
  } else if (!l && !!r) {
    return 1;
  }
  return 0;
}

export default {
  props: {
    numero: {
      type: String,
      required: true,
    },
  },
  mixins: [
    makeRouteLoader({
      promise({ numero }) {
        return requeteService.chargeRequete(numero);
      },
      next({ vm, body }) {
        vm.charge(body);
      },
    }),
  ],
  data() {
    return {
      documents: [],
      projection: null,
      association: null,
      etat: null,
      radieeOffice: false,
      rectifieeOffice: false,
    };
  },

  computed: {
    aucunDocument() {
      return !this.documents.length;
    },
    aucunDocumentDDP() {
      return !this.documentsTriesDDP.length;
    },
    documentsTriesDDP() {
      return (
        this.documents
          // 1. Juste les "DEMANDE_PIECES"
          .filter(doc => TYPES_DEMANDE_PIECES.includes(doc.type))
          // 2. Trier par code
          .sort((l, r) => {
            const pieces = compareBool(!!l.demandePieces, !!r.demandePieces);
            if (pieces !== 0) return pieces;

            return r.idPieces - l.idPieces;
          })
      );
    },
    aucunDocumentFinTraitement() {
      return !this.documentsTriesFinTraitement.length;
    },
    documentsTriesFinTraitement() {
      return (
        this.documents
          // 1. Tous sauf les "DEMANDE_PIECES"
          .filter(doc => !TYPES_DEMANDE_PIECES.includes(doc.type))
          // 2. Trier par type
          .sort((a, b) => {
            const priorite = a.priorite - b.priorite;
            if (priorite != 0) return priorite;

            return b.nom.localeCompare(a.nom);
          })
      );
    },
  },

  methods: {
    charge(body) {
      this.projection = body.projection;
      this.association = body.association;
      const id = this.projection.id;
      this.documents = body.documents.map(d => ({
        ...d,
        lien: d.lien?`/api/requete/${id}/document${d.lien}`:null,
        idPieces: extraitCodePiece(d),
        priorite: extraitPriorite(d),
      }));
      this.etat = body.etat;
      this.radieeOffice = body.radieeOffice;
      this.rectifieeOffice = body.rectifieeOffice;
    },
  },
};
</script>

<style scoped>
.full-width {
  width: 100%;
  padding: 10px;
}
</style>
